import React from 'react';

import * as S from './styles';
import { IProps } from './types';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import IconCoins from '../../../images/icons/coins-solid.svg';
import IconWallet from '../../../images/icons/wallet-solid.svg';
import IconCreditCard from '../../../images/icons/credit-card-regular.svg';
import UPILogo from './images/bhim-upi-icon.png';
import { checkout_paymentTypeAvailabilityList } from "@components/pages/CheckoutPage/__generated__/checkout";

const CheckoutPaymentMethod: React.FC<IProps> = ({
  formik,
  checkout,
  setCheckout,
  setCodSelected,
  loading,
}: IProps) => {
  const handleChange = async (e: any) => {
    e.persist();
    const paymentType = e.target.value;
    if (paymentType === 'COD') {
      setCodSelected(true);
    } else {
      setCodSelected(false);
    }
    formik.setFieldValue('paymentType', paymentType);
    formik.submitForm();
  };

  function CheckoutPaymentCustomMethodTitle(availablePayment:checkout_paymentTypeAvailabilityList) {
    if(availablePayment.key === "CASHFREE" || availablePayment.key === "PREPAID" ){
      return "Prepaid"
    }
    else
      return availablePayment.title
  }

  return (
    <S.Wrapper defaultActiveKey="0">
      <form onSubmit={formik.handleSubmit}>
        <S.CheckoutPaymentMethodCard>
          <S.CheckoutPaymentMethodCardHeader>
            <S.CheckoutPaymentMethodCardHeaderTitle eventKey="0">
              Step2 : Select Payment Method
            </S.CheckoutPaymentMethodCardHeaderTitle>
          </S.CheckoutPaymentMethodCardHeader>
          <S.CheckoutPaymentMethodCardCollapse eventKey="0">
            <S.CheckoutPaymentMethodCardBody>
              <Container>
                <Row>
                  <Col style={{ padding: 0 }}>
                    {checkout?.paymentTypeAvailabilityList
                      ?.filter((paymentTypeAvailability) => paymentTypeAvailability.canBeShown)
                      ?.map((availablePayment) => (
                        <S.CheckoutPaymentMethodCardBodyContent
                          key={availablePayment.key}
                          disabled={!availablePayment.available}
                        >
                          <S.PaymentMethodLabel>
                            <Card.Body>
                              <Row>
                                <S.SelectCol md={2} xs={2}>
                                  <input
                                    type="radio"
                                    name="paymentType"
                                    checked={formik.values.paymentType === availablePayment.key}
                                    onChange={handleChange}
                                    value={availablePayment.key}
                                    disabled={loading || !availablePayment.available}
                                  />
                                </S.SelectCol>
                                <Col md={10} xs={10}>
                                  <h3>{CheckoutPaymentCustomMethodTitle(availablePayment)}</h3>
                                  <S.PaymentMethodTable borderless={true}>
                                    <tbody>
                                      <tr>
                                        <S.PaymentMethodTextTd>{availablePayment.subTitle}</S.PaymentMethodTextTd>
                                      </tr>
                                    </tbody>
                                  </S.PaymentMethodTable>
                                </Col>
                              </Row>
                            </Card.Body>
                          </S.PaymentMethodLabel>
                        </S.CheckoutPaymentMethodCardBodyContent>
                      ))}
                  </Col>
                </Row>
              </Container>
            </S.CheckoutPaymentMethodCardBody>
          </S.CheckoutPaymentMethodCardCollapse>
        </S.CheckoutPaymentMethodCard>
      </form>
    </S.Wrapper>
  );
};

export { CheckoutPaymentMethod };
